export default {
  GET_ALL: 'getAllCustomerProperties',
  GET_CUSTOMER_PROPERTIES_BY_TENANT: 'getCustomerPropertiesByTenant',
  SAVE_CUSTOMER_PROPERTY: 'saveCustomerProperty',
}